import { render, staticRenderFns } from "./editPopup.vue?vue&type=template&id=23096eeb&scoped=true"
import script from "./editPopup.vue?vue&type=script&lang=js"
export * from "./editPopup.vue?vue&type=script&lang=js"
import style0 from "./editPopup.vue?vue&type=style&index=0&id=23096eeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23096eeb",
  null
  
)

export default component.exports